export const analysisMixin = {
  props: {
    dateRange: Object,
    employmentStatus: String
  }
}
